export default function deepCopy(object) {
  var output = Array.isArray(object) ? [] : {}
  for (var data in object) {
    var value = object[data]
    output[data] = typeof value === 'object' ? deepCopy(value) : value
  }
  return output
}
